import { createFileRoute, redirect } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { can } from '@/auth/me'

// Charts are loaded only here, so the rep bundle stays small.
const Dashboard = lazy(() => import('@/features/dashboard/dashboard'))

export const Route = createFileRoute('/_app/dashboard')({
  beforeLoad: ({ context }) => {
    if (!can(context.me, 'dashboard.view')) throw redirect({ to: '/' })
  },
  component: DashboardRoute,
})

function DashboardRoute() {
  const { me } = Route.useRouteContext()
  return (
    <Suspense fallback={<p className="text-fg-muted">Loading the dashboard...</p>}>
      <Dashboard impersonating={me.impersonating} />
    </Suspense>
  )
}
